import { useEffect, useState } from "react";
import "./index.scss";

const Cookies = () => {
    const [modal, setModal] = useState(false);
    const [desnecessarios, setDesnecessarios] = useState(true);
    const [showCookies, setShowCookies] = useState(false);
    useEffect(() => {
        if (!localStorage.acceptCookies) {
            setShowCookies(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("acceptCookies", new Date().toString());
        localStorage.setItem("acceptCookiesDesnecessarios", desnecessarios);
        setShowCookies(false);
    }
    return (
        <>
            <div className={`adjust-cookies-modal ${!modal ? "hide" : ""}`}>
                <div className="adjust-cookies-modal_content">
                    <div className="adjust-coookies-modal_header">
                        <div className="adjust-coookies-modal_topo">
                            <p className="title">Visão geral de privacidade</p>
                            <button className="btn-fechar-modal toggle-modal" onClick={() => setModal(false)}>
                                X
                            </button>
                        </div>
                        <p>
                            Este site usa cookies para melhorar sua experiência enquanto você navega pelo site. Destes cookies,
                            os cookies que são categorizados como necessários são armazenados no seu navegador, pois são
                            essenciais para o funcionamento das funcionalidades básicas do site. Também usamos cookies de
                            terceiros que nos ajudam a analisar e entender como você usa este site. Esses cookies serão
                            armazenados em seu navegador apenas com o seu consentimento. Você também tem a opção de cancelar
                            esses cookies. Porém, a desativação de alguns desses cookies pode afetar sua experiência de
                            navegação.
                        </p>
                    </div>
                    <div className="adjust-cookies-modal_body">
                        <div className="cookie">
                            <p className="subtitle">Cookies Necessários</p>
                            <div className="cookie-active">Sempre ativado</div>
                            <p>Os cookies necessários são absolutamente essenciais para o funcionamento adequado do site. Esta
                                categoria inclui apenas cookies que garantem funcionalidades básicas e recursos de segurança do
                                site. Esses cookies não armazenam nenhuma informação pessoal.</p>
                        </div>
                        <div className="cookie">
                            <p className="subtitle">Cookies Não Necessários</p>
                            <div className="cookie-active">
                                <span className="active-desnecessario">{desnecessarios ? "Ativado" : "Desativado"}</span>
                                <label className="switch">
                                    <input type="checkbox" checked={desnecessarios} id="cookies-desnecessarios" onChange={(e) => setDesnecessarios(e.target.checked)} />
                                    <label htmlFor="cookies-desnecessarios"><span className="slider round"></span></label>
                                </label>
                            </div>
                            <p>Quaisquer cookies que possam não ser particularmente necessários para o funcionamento do site e
                                sejam usados ​​especificamente para coletar dados pessoais do usuário por meio de análises,
                                anúncios e outros conteúdos incorporados.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`accept-cookies ${!showCookies ? "hide" : ""}`}>
                <div className="accept-cookies_header">
                    <p className="accept-cookies_message">
                        Usamos cookies em nosso site para fornecer uma experiência mais relevante, lembrando suas preferências e
                        visitas repetidas. Ao clicar em “Aceitar”, concorda com a utilização de todos os cookies
                    </p>
                </div>
                <div className="accept-cookies_buttons">
                    <button className="adjust toggle-modal" id="adjustCookiesButton" onClick={() => setModal(true)}>
                        Ajustes
                    </button>
                    <button className="accept" id="acceptCookiesButton" onClick={() => acceptCookies()}>
                        Aceitar
                    </button>
                </div>
            </div>
        </>
    )
}

export default Cookies;